export default function($) {
  function initProductGallery() {
    const mainSwiper = window.jsProductMainSwiper;
    const thumbsSwiper = window.jsProductThumbnailsSwiper;
    const mainImage = document.getElementById("main-image");
    const mainImageLink = document.getElementById("main-image-full");

    // Click on thumbnails
    $(".js-product-thumb").on("click", function() {
      const newSrc = $(this).data("full") || this.src;
      const newSrcset = $(this).data("srcset") || "";

      mainImage.src = newSrc;
      mainImage.srcset = newSrcset;

      if (mainImageLink) mainImageLink.href = newSrc;

      const index = $(this).closest(".swiper-wrapper").children().index($(this).parent());
      if (!isNaN(index)) mainSwiper.slideTo(index);
    });

    // Load variation image when variation change
    $(document).on('found_variation', '.variations_form', function(event, variation) {
      if (variation?.image?.src) {
        const newSrc = variation.image.full_src || variation.image.src;
        const newSrcset = variation.image.srcset || "";

        mainImage.src = newSrc;
        mainImage.srcset = newSrcset;

        if (mainImageLink) mainImageLink.href = newSrc;

        const slides = Array.from(mainSwiper.slides);
        const slideIndex = slides.findIndex(slide => {
          const img = slide.querySelector('img');
          return img?.src === newSrc;
        });
        if (slideIndex !== -1) mainSwiper.slideTo(slideIndex);
      }
    });
  }

  $('.variations_form').each(function () {
    const $form = $(this);

    // Init add to cart variation script
    if (typeof $form.wc_variation_form === 'function') {
      $form.wc_variation_form();
    }

    // Select first variation combination
    const variations = $form.data('product_variations');

    // Handle click on variation labels
    $form.on('click', '.js-attribute-label', function (e) {
      e.preventDefault();

      const $radio = $(this).find('input[type=radio]');
      if (!$radio.length) return;

      const name = $radio.attr('name');
      const value = $radio.val();

      $radio.prop('checked', true);
      $form.find(`select[name="${name}"]`).val(value).trigger('change');

      $(this).closest('.js-attribute-options')
        .find('.js-attribute-label')
        .removeClass('is-active');
      $(this).addClass('is-active');
    });

    // Keep the initial rendered HTML (price + potential price/kg)
    const $priceContainer = $form.find('.variation-price');
    const initialPriceHtml = $priceContainer.length ? $priceContainer.html() : '';
    const defaultPriceHtml = $priceContainer.data('default-price-html') || '';

    // Update displayed price on variation and keep price/kg visible
    $form.on('found_variation', function (event, variation) {
      if (!$priceContainer.length || !variation) return;

      // For subscribable variations use the plain one-time price (not WCSATT-modified price_html).
      // For regular variations keep the standard WooCommerce price_html
      const hasSubscriptionSchemes = Array.isArray(variation.gt_subscription_schemes) && variation.gt_subscription_schemes.length > 0;
      const oneTimePriceHtml = hasSubscriptionSchemes ? (variation.gt_one_time_price_html || '').trim() : '';
      const priceHtml = oneTimePriceHtml || (variation.price_html || '').trim();
      const pricePerKgHtml = (variation.price_per_kg || '').trim();

      const computedMainPrice = (
        priceHtml ||
        (variation.display_price !== undefined && variation.display_price !== null
          ? `<span class="price"><span class="woocommerce-Price-amount amount"><bdi>${Number(variation.display_price).toFixed(2).replace('.', ',')}<span class="woocommerce-Price-currencySymbol">€</span></bdi></span></span>`
          : '') ||
        defaultPriceHtml
      );

      if (!computedMainPrice && !pricePerKgHtml) {
        $priceContainer.html(initialPriceHtml);
        return;
      }

      const regPrice  = parseFloat(variation.display_regular_price);
      const dispPrice = parseFloat(variation.display_price);
      let discountBadge = '';
      if (regPrice > 0 && dispPrice < regPrice) {
        const pct = Math.round(((regPrice - dispPrice) / regPrice) * 100);
        discountBadge = `<span class="flex items-center justify-center size-10 rounded-full border-2 border-primary bg-white text-primary text-xs font-bold shadow-sm p-1 leading-none whitespace-nowrap">-${pct}%</span>`;
      }

      let html = `<div class="flex flex-wrap items-end gap-2"><div>${computedMainPrice || ''}</div>${discountBadge}</div>`;
      if (pricePerKgHtml) {
        const eitherLabel = (window.gtProductTrans && window.gtProductTrans.either) ? window.gtProductTrans.either : 'soit';
        html += '<span class="price-per-kilo">(' + (eitherLabel ? eitherLabel + ' ' : '') + pricePerKgHtml + ')</span>';
      }

      $priceContainer.html(html || initialPriceHtml);
    });

    // Restore initial block on reset
    $form.on('reset_data', function () {
      if ($priceContainer.length) {
        $priceContainer.html(initialPriceHtml || defaultPriceHtml || '');
      }
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductGallery);
  } else {
    initProductGallery();
  }
}
